import React, { useMemo } from "react";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { isStartListStatus, isLiveStatus } from "helpers/status";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
//General
import Status from "components/presentation/Status";
import Label from "components/general/Label"
import NotAvailable from 'components/common/NotAvailable'
import {
    TableColumns as ColumnsStart,
    TableColumnsSM as ColumnsStartSM
} from 'components/sports/tri/events/individual/start/Columns'
import {
    TableColumnsLive as ColumnsResLive,
    TableColumnsLiveParasEventsPTVPTW as ColumnsResLivePTVPTW,
    TableColumnsLiveSM as ColumnsResLiveSM,
    TableColumnsFinish as ColumnsRes,
    TableColumnsFinishParasEventsPTVPTW as ColumnsResPTVPTW,
    TableColumnsFinishSM as ColumnsResSM
} from 'components/sports/tri/events/individual/summary/Columns'


//import TableMin from "components/table/TableMin";
import { useViewport } from 'components/general/useViewPort'
import { findArray } from 'helpers/utils'
import { getIsPTVPTW } from "../helper/TriHelpers";




const getConfiguration = (data, rsc, resultStatus, breakPoint, caption) => {

    const dataAdditional = data?.results?.extendedInfos
    const isStartList = isStartListStatus(resultStatus) ? true : false
    const isLive = isLiveStatus(resultStatus) ? true : false
    let isPTVPTW = getIsPTVPTW(rsc);

    //determinar si la configuacion viene del config o del result depende del deporte
    let columnsAdded
    columnsAdded = data?.config?.extendedConfig ? data.config.extendedConfig.sort((a, b) => a.pos - b.pos) : []





    let configuration = {
        caption: null,
        columns: [],
        //subComponent: null,
        hiddenColumns: [],
        sortBy: [],
        filters: {
            ei_type: ['NONE'],
            ei_code: ['NONE']
        },
        configs: {
            isStartList: isStartList,
            columnsAdded: columnsAdded,
            previousCurrent: false,
            dataAdditional: dataAdditional
        }
    };

    configuration.caption = <CaptionTable
        leftCol={<Label data="LabelSummary" />}
        //centerCol={<span className="text-dark">{resultStatus}</span>}
        rightCol={<Status typeToPrint='result' scheduleStatus={data?.results?.schedule?.status?.code} resultStatus={resultStatus} />}
    />

    configuration.sortBy = isStartList
        ? [{ id: 'Bib', desc: false }]
        : [{ id: 'RankSummary', desc: false }]




    configuration.filters = {
        ei_type: ['DISPLAY'],
        ei_code: ['INTERMEDIATE_CURRENT']
    };



    configuration.columns = isStartList
        ? breakPoint === "sm" || breakPoint === "xs"
            ? ColumnsStartSM()
            : ColumnsStart()
        : isLive
            ? breakPoint === "sm" || breakPoint === "xs"
                ? ColumnsResLiveSM(columnsAdded)
                : isPTVPTW ? ColumnsResLivePTVPTW(columnsAdded) : ColumnsResLive(columnsAdded)
            : breakPoint === "sm" || breakPoint === "xs"
                ? ColumnsResSM(columnsAdded)
                : isPTVPTW ? ColumnsResPTVPTW(columnsAdded) : ColumnsRes(columnsAdded)

    return configuration;
};


const TriSummary = ({ data, caption }) => {
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;

    //Cuando cambimos de estado de resultados forzamos a repintar la tabla con las nuevas columnas 
    //aunque no hay cambios    
    // eslint-disable-next-line
    const configEvent = useMemo(() => getConfiguration(data, mirs_rsc, resultStatus, breakPoint, caption), [resultStatus, mirs_rsc, breakPoint]);
    // Create a function that will render our row sub components
    const items = data?.results?.items

    //const showAllresultAnalysis = items?.some(item => item?.resultAnalysis?.extendedResults?.some(item => item.er_code === 'INTERMEDIATE'));
    //const showAllTeamAthletes = items?.teamathletes?.some(val => val.hasOwnProperty('athlete'));
    //const showAll = showAllExtendedResults || showAllTeamAthletes;

    //const hasConfiguration = hasConfig(configEvent.configs.columnsAdded)


    //Si el contenido de una columna esta vacia la ocultamos(ver casos)
    //Pasamos el id de la columna a ocultar definido en la configuracón de
    let hiddenColumns = []

    const filtersFinalSplit = {
        ei_type: ['UI'],
        ei_code: ['INTERMEDIATES_TOTAL']
    };


    let extendedInfos = data?.results?.extendedInfos
    let finalSplit = extendedInfos && findArray(extendedInfos, filtersFinalSplit).ei_value;
    let currentSplit = extendedInfos && findArray(extendedInfos, configEvent.filters).ei_value;


    currentSplit = (currentSplit === 'F') ? finalSplit : currentSplit // ponemos un numero muy alto prar que internamente se posicione en el ultimo 
    currentSplit = (currentSplit === undefined) ? 1 : currentSplit
    //numero de splits visibles 
    const extendedColsVisibles = (breakPoint === "sm" || breakPoint === "xs") ? 2 : 4;
    //const colIndex = (breakPoint === "sm" || breakPoint === "xs") ? 1 : 2;


    return (
        <>
            {data?.results ? (
                <>

                    {data?.results?.items ? (
                        < MirsTable
                            className='table-result'
                            //Dato to show by row
                            data={data.results.items}
                            //Columnas a visualizar 
                            columns={configEvent.columns}
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            //Splits to show
                            colsExtendedVisible={extendedColsVisibles}
                            hasRelatedTimeline={false}
                            //current split (initial)
                            // colIndex={colIndex} //Columna Posicionada con splits
                            //Component caption
                            caption={configEvent.caption}
                            //Columns to hidde 
                            hiddenColumns={hiddenColumns}
                            //When show tble is sorted by 
                            initialSortBy={configEvent.sortBy}
                            //Show buttons move to splits 
                            showNavExtendedData={true}
                            id={`mirs-table-summary-${mirs_rsc}`}
                        />
                    ) : ('')
                    }

                </>
            ) : (
                <NotAvailable />
            )
            }

        </>
    );
};

export default TriSummary;
